"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigeekIconSVG = void 0;
const React = __importStar(require("react"));
const ConfigeekIconSVG = () => React.createElement("svg", { width: "1em", height: "1em", version: "1.1", viewBox: "0 0 1230 400", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { transform: "matrix(4.6234 0 0 4.6234 -532.99 -1098.5)", fill: "#2b3541" },
        React.createElement("polygon", { points: "318.8 393.9 318.8 331.9 335.3 331.9 335.3 410.4 157.2 410.4 157.2 331.9 173.7 331.9 173.7 393.9" }),
        React.createElement("path", { d: "m335.2 315.5v-69.6h-69.6v28.3h-38.6v-28.3h-69.6v69.6h69.6v-24.8h38.5v49.1h-46.5v16.5h63v-40.9h53.2zm-52.1-51.9h36v36h-36zm-72 36.5h-36v-36.9h36z" }),
        React.createElement("polygon", { points: "292.6 211.7 292.5 211.6 280 197.5 279.8 197.5 284.9 173.6 273.1 167.6 268.8 173.4 258.8 186.7 258.7 186.7 240 186.6 239.9 186.7 226.4 167.1 213.7 172.8 214.7 181.1 216.5 197.8 216.5 197.8 202.9 211 202.9 211.1 180.2 206.6 175.3 219.8 171.3 230.8 157.3 230.8 163.1 215.1 163.1 215.1 171.8 191.4 171.8 191.4 184.8 193.9 198.7 196.7 202.8 192.7 199.6 164.6 231 150.4 246.7 173.3 252.4 173.3 268.6 151.7 269 150.7 299.8 166.1 299.8 166.1 299.9 166.1 294.1 193.5 297.9 197.8 310.4 196.6 323.7 195.4 326.1 202.8 330.1 215.4 330.2 215.6 335 230.8 321.2 230.8 317.7 219.6 314.5 209.6 308.9 210.2" })));
exports.ConfigeekIconSVG = ConfigeekIconSVG;
